import React from "react";
import { useLocation } from "react-router-dom";
import StaffForm from "../Staff/StaffForm";

const VendorStaffForm = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const vendorId = searchParams.get("vendorId");
    const vendorName = searchParams.get("vendorName");

    return <StaffForm initialVendorId={vendorId} initialVendorName={vendorName} />;
};

export default VendorStaffForm;
